import * as i0 from '@angular/core';
import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { of, timer } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';
import moment from 'moment/moment';

class CountdownComponent {
    constructor() {
        /** The time that the end date was requested - used to return time remaining more accurately than using moment.utc */
        this.requestDateTime = '';
        /** The text to display in the countdown upon expiry. */
        this.completeText = 'Complete';
        /** determines whether component will receive local or utc time. default is utc. */
        this.isUTC = true;
        /** Emitted upon countdown expiry. */
        this.complete = new EventEmitter();
        this.completed = false;
    }
    ngOnInit() {
        this.setTimer(this.endDateTime);
    }
    ngOnChanges(changes) {
        if (changes.endDateTime) {
            this.setTimer(changes.endDateTime.currentValue);
        }
    }
    /**
     * Sets the countdown timer relative to the supplied endDateTime.
     * @param endDateTime The time that the countdown should end as a UTC date.
     */
    setTimer(endDateTime) {
        this.endDate = this.isUTC ? moment.utc(endDateTime) : moment.utc(new Date(endDateTime).toUTCString());
        this.setRequestDate();
        if (this.endDate < this.requestDate) {
            this.completed = true;
            this.complete.emit(this.completed);
            this.formattedTime$ = of(this.completeText);
        }
        else {
            this.completed = false;
            this.formattedTime$ = timer(0, 1000).pipe(
            // convert interval into remaining time in seconds
            map(() => {
                this.setRequestDate();
                let utcNow = this.requestDate;
                return Math.floor(this.endDate.diff(utcNow, 'seconds'));
            }), 
            // stop emission after complete
            filter(() => !this.completed), 
            // emit on complete
            tap((t) => {
                if (t <= 0) {
                    this.completed = true;
                    this.complete.emit(this.completed);
                }
            }), map(this.formatRemainingTime));
        }
    }
    setRequestDate() {
        this.requestDate = this.requestDateTime.length > 0 ? moment(this.requestDateTime) : moment.utc();
        this.requestDate = this.isUTC ? moment.utc(this.requestDate) : moment.utc();
    }
    formatRemainingTime(seconds) {
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds / 60);
        if (days) {
            const remainderHours = Math.floor((seconds % 86400) / 3600);
            return `${days}D ${remainderHours}H`;
        }
        else if (hours) {
            const remainderMinutes = Math.floor((seconds % 3600) / 60);
            return `${hours}H ${remainderMinutes}M`;
        }
        else if (minutes) {
            const remainderSeconds = seconds % 60;
            return `${minutes}M ${remainderSeconds}S`;
        }
        else {
            return `${seconds}S`;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.2.1", type: CountdownComponent, selector: "fgbcl-countdown", inputs: { endDateTime: "endDateTime", requestDateTime: "requestDateTime", completeText: "completeText", isUTC: "isUTC" }, outputs: { complete: "complete" }, usesOnChanges: true, ngImport: i0, template: "<span *ngIf=\"!completed; else showComplete\" class=\"countdown-timer fw-bold\">\r\n  {{ formattedTime$ | async }}\r\n</span>\r\n<ng-template #showComplete>\r\n  <span>\r\n    {{ completeText }}\r\n  </span>\r\n</ng-template>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'fgbcl-countdown', template: "<span *ngIf=\"!completed; else showComplete\" class=\"countdown-timer fw-bold\">\r\n  {{ formattedTime$ | async }}\r\n</span>\r\n<ng-template #showComplete>\r\n  <span>\r\n    {{ completeText }}\r\n  </span>\r\n</ng-template>\r\n" }]
        }], ctorParameters: () => [], propDecorators: { endDateTime: [{
                type: Input
            }], requestDateTime: [{
                type: Input
            }], completeText: [{
                type: Input
            }], isUTC: [{
                type: Input
            }], complete: [{
                type: Output
            }] } });

class CountdownModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.2.1", ngImport: i0, type: CountdownModule, declarations: [CountdownComponent], imports: [CommonModule], exports: [CountdownComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountdownModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.2.1", ngImport: i0, type: CountdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CountdownComponent],
                    imports: [CommonModule],
                    exports: [CountdownComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CountdownComponent, CountdownModule };
